module.exports = __webpack_public_path__ + "assets/293edcc80314803a9c6093b19ac081ab.jpg";